import gql from 'graphql-tag';

export const dvrDeviceListItemFields = gql`
  fragment DvrDeviceListItemFields on DvrDeviceListItem {
    id
    name
    placeId
    ip
    serialNumber
    firmwareVersion
    isOnline
    serializedParams
    cannels
    creationDate
    lastUpdate
    deviceType {
      id
      name
      fieldName
      manufacturer
    }
    deviceModel {
      id
      name
      fieldName
    }
  }
`;

export const dvrCameraItemFields = gql`
  fragment DvrCameraItemFields on DvrCameraItem {
    id
    name
    camName
    thumbnail
    porterVideoChannel
    cameraPlaces {
      placeId
      name
    }
    creationDate
    lastUpdate
  }
`;

export const deviceUserFields = gql`
  fragment DeviceUserFields on DeviceUser {
    entityId
    deviceUserId
    name
    linkId
    type
    faceStatus
    tagsDevice
    tagsExpected
  }
`;
